module.exports = __webpack_public_path__ + "static/media/wetlands-world-full.195acfe1.jpg";